export const SELECTED_PAIR_KEY = 'APP_SELECTED_PAIR';
